export default "__VITE_ASSET__wDCILSet__"